import styles from './Checkbox.module.scss'
import React from 'react'
import classNames from 'classnames'

type Props = {
  label: string,
  name: string,
  checked: boolean,
  onChange: (checked: boolean, name: string) => void,
  margin?: boolean,
  disabled?: boolean,
  wrap?: boolean,
}

const Checkbox = (props: Props) => {

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target
    props.onChange(checked, props.name)
  }

  const classes = classNames(
    styles.component,
    {
      [styles.active]: props.checked,
      [styles.margin]: props.margin,
      [styles.disabled]: props.disabled,
      [styles.wrap]: props.wrap,
    }
  )

  return (
    <div className={classes}>
      <label htmlFor={props.name}>
        <input
          type="checkbox"
          name={props.name}
          id={props.name}
          checked={props.checked}
          onChange={onChange}
          disabled={props.disabled}
        />
        <div className={styles.radio}>
          <div className={styles.radioInner} />
        </div>
        <div className={styles.text}>{props.label}</div>
      </label>
    </div>
  )
}

export default Checkbox